import { render, staticRenderFns } from "./NutrientsForm.vue?vue&type=template&id=31d2ffd9&"
import script from "./NutrientsForm.vue?vue&type=script&lang=js&"
export * from "./NutrientsForm.vue?vue&type=script&lang=js&"
import style0 from "./NutrientsForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports